import React from "react";

export const Cartridge = () => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="15px"
      height="15px"
      viewBox="0 0 64 64"
    >
      <path d="m32 32a4 4 0 0 0 -4 4v4a4 4 0 0 0 8 0v-4a4 4 0 0 0 -4-4zm2 8a2 2 0 0 1 -4 0v-4a2 2 0 0 1 4 0z" />
      <path d="m33 62v-10h2v10h2v-10.667l2.8-3.733a1.842 1.842 0 0 0 .124-.226 1.882 1.882 0 0 0 .076-.374v-17.764l1.9-3.789a1 1 0 0 0 -.9-1.447h-1v-6h2v-2h-2v-5a3 3 0 0 0 -3-3h-2v-6h-6v6h-2a3 3 0 0 0 -3 3v5h-2v2h2v6h-1a1 1 0 0 0 -.895 1.447l1.895 3.789v17.764a1.882 1.882 0 0 0 .076.374 1.842 1.842 0 0 0 .124.226l2.8 3.733v10.667h2v-10h2v10zm2.5-12h-7l-1.5-2h10zm-9.5-20h12v16h-12zm12.382-2h-12.764l-1-2h14.764zm-7.382-24h2v4h-2zm-5 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1h-12zm0 3h12v2h-12zm0 4h12v6h-12z" />
      <path d="m34 20h2v2h-2z" />
      <path d="m30 20h2v2h-2z" />
    </svg>
  );
};
